import React, { useState, useEffect } from 'react';
import * as Styled from '../Dashboard.styles';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Card from '../../../components/Card/Card';
import { dailyMovementsFetchAction } from '../../../store/fetchActions/dailyMovementsActions';
import { useDispatch, useSelector } from 'react-redux';
import { theme } from '../../../styles/theme';
const { mainColor, secondaryColor, lightPink } = theme.colors;

export default function CardContainer() {
  const dispatch = useDispatch();

  const [isExpanded, setIsExpanded] = useState(false);
  useEffect(() => {
    const listMovements = () =>
      dispatch(dailyMovementsFetchAction({ limit: 10, page: 1 }));
    listMovements();
  }, [dispatch]);

  const extendedHeight = '19vw';
  const contractedHeight = '5.417vw';

  const {
    TOTAL_CARTAO_DEBITO,
    TOTAL_CREDITO,
    TOTAL_DEBITO,
    TOTAL_DEPOSITO,
    TOTAL_EMPRESTIMO,
    TOTAL_PAGAMENTO,
    TOTAL_PIX,
    TOTAL_TARIFAS,
    TOTAL_TRANSACAO_INTERNA_CREDITO,
    TOTAL_TRANSACAO_INTERNA_DEBITO,
  } = useSelector((state) => state.dailyMovements.infos);

  return (
    <Styled.CardContainer>
      <Styled.CardElement>
        <Card
          icon={<ArrowUpwardIcon />}
          iconColor={secondaryColor}
          backgroundColorContainer={'#1014101A'}
          expandedHeight={extendedHeight}
          height={contractedHeight}
          name="Crédito"
          text="Valor total:"
          value={TOTAL_CREDITO}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
          data={[
            {
              name: 'Boleto',
              value: TOTAL_DEPOSITO,
            },
            {
              name: 'Empréstimos',
              value: TOTAL_EMPRESTIMO,
            },
            {
              name: 'Tarifa',
              value: TOTAL_TARIFAS,
            },
            {
              name: 'Transferência entre contas',
              value: TOTAL_TRANSACAO_INTERNA_CREDITO,
            },
          ]}
          color={secondaryColor}
        ></Card>
      </Styled.CardElement>
      <Styled.CardElement>
        <Card
          icon={<ArrowDownwardIcon />}
          iconColor={mainColor}
          backgroundColorContainer={lightPink}
          expandedHeight={extendedHeight}
          height={contractedHeight}
          name="Débito"
          text="Valor total:"
          value={TOTAL_DEBITO}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
          data={[
            {
              name: 'Cartões',
              value: TOTAL_CARTAO_DEBITO,
            },
            {
              name: 'Pagamentos',
              value: TOTAL_PAGAMENTO,
            },
            {
              name: 'Transferências',
              value: TOTAL_PIX,
            },

            {
              name: 'Transferência entre contas',
              value: TOTAL_TRANSACAO_INTERNA_DEBITO,
            },
          ]}
          color={mainColor}
        ></Card>
      </Styled.CardElement>
    </Styled.CardContainer>
  );
}
